import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const Impressum: React.FC = () => {
  const { t } = useTranslation("impressum");

  return (
    <div className="flex flex-col justify-center items-start bg-white-100">
      <Box
        sx={{
          position: "relative",
          height: "30vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
          }}
        />
        <Box
          sx={{
            position: "relative",
            zIndex: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            textAlign: "center",
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: "2rem",
              fontWeight: "600",
              maxWidth: "750px",
              color: "black",
              textTransform: "uppercase",
            }}
          >
            {t("Title")}
          </Typography>
        </Box>
      </Box>

      <div className="flex flex-col justify-center items-start bg-white-100 pb-16 px-8 lg:px-36">
        <div className="flex flex-col justify-center lg:w-1/1 text-left text-text lg:pr-12 mb-16 lg:mb-0 self-start">
          <p className="text-lg font-montserrat font-medium  mt-2">
            {t("Text")}
          </p>
          <p className="text-lg font-montserrat font-medium  mt-2">
            {t("Text1.1")}
          </p>
          <p className="text-lg font-montserrat font-medium  mt-2">
            {t("Text1.2")}
          </p>
        </div>

        <div className="flex flex-col">
          <div className="flex flex-col justify-center items-center ">
            <div className="flex flex-col justify-center lg:w-1/1 text-left text-text  mb-16 lg:mb-0 self-start">
              <h2 className="font-bold  text-lg  py-5">{t("Title1")}</h2>
              <p className="text-lg font-montserrat font-medium">
                {t("Text1")}
              </p>
              <p className="text-lg font-montserrat font-medium">
                {t("Text1.3")}
              </p>
            </div>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="flex flex-col justify-center lg:w-1/1 text-left text-text mb-16 lg:mb-0 self-start">
              <h2 className="font-bold  text-lg  py-5 ">{t("Title2")}</h2>
              <p className="text-lg font-montserrat font-medium">
                {t("Text2")}
              </p>
            </div>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="flex flex-col justify-start lg:w-1/1 text-left text-text mb-16 lg:mb-0 self-start">
              <h2 className="font-bold  text-lg  py-5">{t("Title3")}</h2>
              <p className="text-lg font-montserrat font-medium">
                {t("Text3")}
              </p>
            </div>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="flex flex-col justify-center lg:w-1/1 text-left text-text mb-16 lg:mb-0 self-start">
              <h2 className="font-bold  text-lg  py-5 ">{t("Title4")}</h2>
              <p className="text-lg font-montserrat font-medium">
                {t("Text4")}
              </p>
            </div>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="flex flex-col justify-center lg:w-1/1 text-left text-text mb-16 lg:mb-0 self-start">
              <h2 className="font-bold  text-lg  py-5 ">{t("Title5")}</h2>
              <p className="text-lg font-montserrat font-medium">
                {t("Text5")}
              </p>
            </div>
          </div>
          <div className="flex flex-col   pb-10 pt-5 justify-center items-center">
            <div className="flex flex-col border-t justify-center lg:w-1/1 text-left text-text mb-16 lg:mb-0 self-start">
              <h2 className="font-bold  text-lg  py-5 ">{t("Title6")}</h2>
              <p className="text-lg font-montserrat font-medium">
                {t("Text6")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
